query GetUserLicenses($userId: ID!) {
    user(id: $userId) {
        id
        licenses {
            licenseType
            isOwned
        }
    }
}
